export const iconFontAwesomeArrowsArrowDownAZ = (
	<i className="fa-solid fa-arrow-down-a-z"></i>
);
